// extracted by mini-css-extract-plugin
module.exports = {"container":"Reactions_container__27BdD","option":"Reactions_option__1x8G0"};